import { render, staticRenderFns } from "./SurveyContent.vue?vue&type=template&id=72057a4a"
import script from "./SurveyContent.vue?vue&type=script&lang=js"
export * from "./SurveyContent.vue?vue&type=script&lang=js"
import style0 from "./SurveyContent.vue?vue&type=style&index=0&id=72057a4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports